import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import {
  Schedule,
  SchedulePayload,
} from "src/app/shared/interfaces/course-schedule";
import { Guid } from "src/app/shared/types/guid";

export const editSchedulePrefix = "[Edit Schedule List]";

const editScheduleListActions = {
  request: `${editSchedulePrefix} Load`,
  requestActiveSuccess: `${editSchedulePrefix} Load success`,
  requestFail: `${editSchedulePrefix} Load fail`,
};

export const editScheduleLoad = createAction(
  editScheduleListActions.request,
  props<{
    CourseId: Guid;
    GroupId: Guid;
    ScheduleId: Guid;
    schedule: SchedulePayload;
  }>(),
);

export const editScheduleLoadSuccess = createAction(
  editScheduleListActions.requestActiveSuccess,
  props<{ schedule: Schedule }>(),
);

export const editScheduleFailure = createAction(
  editScheduleListActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);
